module.exports = __webpack_public_path__ + "img/status-verify.a4d12e9c.svg";